export const COOPERATION_VOUCHER = {
  VIVIDA_BKK: 'VIVIDA_BKK',
} as const;

export type TCooperationVoucherConfig = Record<
  keyof typeof COOPERATION_VOUCHER | 'FALLBACK',
  {
    staging: string;
    production: string;
  }
>;

export const COOPERATION_VOUCHER_CONFIG: TCooperationVoucherConfig = {
  [COOPERATION_VOUCHER.VIVIDA_BKK]: {
    staging: '53adb93a-8583-427b-891f-4176db1e20fe',
    production: '72cd49d9-7061-4ffe-a880-011a530bd49a',
  },
  FALLBACK: {
    staging: 'fallback-staging',
    production: 'fallback-production',
  },
};

export const getInsuranceNameByClientKey = (clientKey: string): string | null => {
  for (const value of Object.values(COOPERATION_VOUCHER)) {
    const config = COOPERATION_VOUCHER_CONFIG[value];
    if (config?.staging === clientKey || config?.production === clientKey) {
      return value;
    }
  }
  return null;
};
